import { useState } from "react";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Button, DialogActions, DialogContent, Paper, Typography, Chip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import HotelIcon from "@mui/icons-material/Hotel";
import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";
import { siteName } from "@/constants/config";

const IntroHotels = () => {
  const theme = useThemeData();
  const { isPc } = usePlatform();
  const [visible, setVisible] = useState(false);

  const bgBlack = "https://img.awardtool.com/hotel_bg_black_v2.jpg";
  const bgWhite = "https://img.awardtool.com/hotel_bg_white_v2.jpg";
  const tooltipText = siteName + " selected excellent hotels that could bring you unforgettable experience with your points. Prices cover the necessary points for one adult. Additional fees and charges may be applicable. Our displayed results for hotel bookings are based on cached information, and prices and room availability can fluctuate rapidly, particularly for upcoming dates and popular hotels."

  return (
    <Paper
      elevation={1}
      className="!rounded-[4px] mt-[20px] ml-[10px] mr-[10px]"
      style={{
        backgroundColor: theme.isDarkMode ? "#202124" : "#f1f3fb",
      }}
    >
      <div className="flex items-center justify-between h-[70px]">
        <div className="pl-[20px] flex items-center">
          <div className="w-[30px] h-[30px] mr-[10px]">
            <HotelIcon color="primary" />
          </div>
          <div>
            <div className="flex items-center">
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="body1"
              >
                Award Hotels
              </Typography>
              {/* <Chip
                size="small"
                className="ml-[12px]"
                color="primary"
                label="beta"
                sx={{
                  fontWeight: "bold",
                }}
              /> */}
            </div>
            <Typography className="flex items-center">
              {isPc
                ? "Elevate your award travel experience with selected top-notch hotel stays."
                : "Elevate your award travel experience."}{" "}
              <Tooltip
                sx={{ size: 10 }}
                title={tooltipText}
              >
                <InfoOutlinedIcon
                  onClick={() => {
                    if (!isPc) {
                      setVisible(true);
                    }
                  }}
                  sx={{ fontSize: 16, margin: "auto" }}
                />
              </Tooltip>
            </Typography>
          </div>
        </div>

        {isPc && <img className="h-[100%] mr-[30px]" src={theme.isDarkMode ? bgBlack : bgWhite} alt="" />}

        <Dialog
          open={visible}
          onClose={() => setVisible(false)}
          PaperProps={{
            sx: {
              borderRadius: "12px",
            },
          }}
        >
          <DialogContent>
            <Typography fontSize={16}>
              {tooltipText}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setVisible(false)}>OK</Button>
          </DialogActions>
        </Dialog>
      </div>
    </Paper>
  );
};

export default IntroHotels;
